<template>
	<div class="c-checklist-block__content-wrapper">
		<div class="c-checklist-progress-bar">
			<div
				class="c-checklist-progress-bar__circle"
				:style="circleAnimation"
			>
				<div class="c-checklist-progress-bar__value">
					{{ getCurrentCheckedCount }}/{{ items.totalChekedCount }}
					<div class="c-checklist-progress-bar__text">Avklarat</div>
				</div>
			</div>
		</div>

		<div class="c-checklist-block-item-wrapper">
			<slot name="default">
				<VChecklistBlockItem
					v-for="item in items"
					:key="item.id"
					:id="item.id"
					:title="item.title"
					:description="item.description"
					:link-url="item.linkUrl"
					:link-text="item.linkText"
				/>
			</slot>
		</div>
	</div>
</template>

<script>
import VChecklistBlockItem from "./VChecklistBlockItem.vue";
import VuexStore from "../../js/vuex-store/vuex-store.js";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
	name: "VChecklistCounter",

	store: VuexStore,
	components: {
		VChecklistBlockItem
	},
	props: {
		getCountCurrentChecks: {
			type: Number,
			default: 0
		},
		totalChecked: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			checkCount: 0
		};
	},
	computed: {
		...mapState({
			countCurrentChecks: state => state.checklist.countCurrentChecks,
			checklistType: state => state.checklist.checklistType
		}),
		...mapGetters({
			activeCheckboxes: "checklist/activeCheckboxes"
		}),
		getTotalChecked() {
			return this.activeCheckboxes;
		},
		getCurrentCheckedCount() {
			if (
				this.countCurrentChecks !== 0 &&
				this.countCurrentChecks !== this.getTotalChecked
			) {
				return this.countCurrentChecks;
			} else {
				return this.getTotalChecked;
			}
		},
		items() {
			// Get the items from the default slot
			const items = this.$slots.default
				? this.$slots.default.filter(node => node.tag)
				: [];
			const totalChekedCount = items.length;

			const percentage = `${(this.getCurrentCheckedCount /
				totalChekedCount) *
				100}`;

			return {
				totalChekedCount,
				items,
				percentage
			};
		},
		circleAnimation() {
			return {
				background: `conic-gradient(#57AB27 ${this.items.percentage *
					3.6}deg, #fff 0 0deg)`,
				border: "4px solid #transparent",
				borderRadius: "50%",
				transition: "background 0.5s ease",
				transform: "rotate(0deg)"
			};
		}
	}
};
</script>
